const initialState = {
  LANG: process.env.LANG,
  BRAND_CHANNEL: process.env.BRAND_CHANNEL,
  BRAND_NAME: process.env.BRAND_CHANNEL === 'ni' ? 'nissan' : 'infiniti',
  SLOT: process.env.SLOT,
  VENDOR: process.env.VENDOR
};

export default function reducer(state = initialState, action = {}) {
  switch (action.type) {
    default:
      return state;
  }
}



/** WEBPACK FOOTER **
 ** ./src/redux/reducers/environment.js
 **/